import { Injectable } from '@angular/core';
import { GridApi } from 'ag-grid-community';

@Injectable({
  providedIn: 'root',
})
export class ClipboardService {
  copyToClipboardFromGridApi(gridApi: GridApi) {
    const dataAsCsv = gridApi.getDataAsCsv({
      columnKeys: gridApi
        .getColumns()!
        .filter((col) => col.getColId() !== 'actions' && col.isVisible())
        .map((col) => col.getColId()),
    });
    if (!dataAsCsv) return;

    const formattedText = dataAsCsv.replace(/,/g, '\t');

    navigator.clipboard.writeText(formattedText).then(
      () => console.log('Text copied to clipboard'),
      (err) => console.error('Could not copy text: ', err)
    );
  }
}
